module.exports = __webpack_public_path__ + "img/trevor.75ae39e1.png";